export default { sha: '23d1f815601d572a255ddc5740fd61b35bc4330c', buildNumber: 'undefined' }
